import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetInternalJobQuery } from '../../../../redux/services/fij_internal_jobs.jsx';
import { useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../common/index.jsx';
import FijJobDetail from '../../../common/FijInternalJobs/FijJobDetail.jsx';
import useScrollToTopOnMount from '../../../../hooks/useScrollToTopOnMount.jsx';

const FijJobsDetailPage = () => {
  useScrollToTopOnMount();
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    data: internalJob,
    isLoading,
    refetch,
  } = useGetInternalJobQuery({ id, forDetail: true });

  return (
    <>
      <MainTitle title={t('Detail FRI praxe')} backAction={true} />

      {isLoading ? (
        <Spinner />
      ) : (
        <FijJobDetail
          internalJob={internalJob}
          refetchInternalJobData={refetch}
          onSendInterestClick={() => {}}
          onApproveClick={() => {}}
          onRejectClick={() => {}}
          fromPublic={true}
        />
      )}
    </>
  );
};

export default FijJobsDetailPage;
